import { render } from "./_Pdf.vue?vue&type=template&id=4c8459c6&scoped=true"
import script from "./_Pdf.vue?vue&type=script&lang=ts"
export * from "./_Pdf.vue?vue&type=script&lang=ts"

import "./_Pdf.vue?vue&type=style&index=0&id=4c8459c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c8459c6"

export default script